export enum ViewStatus {
  Loading = 'loading',
  Error = 'error',
  Default = 'default'
}
